// extracted by mini-css-extract-plugin
export default {"header":"FormHeader_header__mCXMM","title":"FormHeader_title__BLe+g","actions":"FormHeader_actions__KizFI","note":"FormHeader_note__e9xU4"};